import { render, staticRenderFns } from "./PriceRuleForm.vue?vue&type=template&id=6841f25a&scoped=true&"
import script from "./PriceRuleForm.vue?vue&type=script&lang=js&"
export * from "./PriceRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841f25a",
  null
  
)

export default component.exports